<template>
  <div>
    <van-image-preview
      v-model="show"
      :closeable="false"
      :show-index="false"
      :images="[`${require('@assets/img-hospital-plan.png')}`]"
      :async-close="true"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: true
    };
  }
};
</script>
